import { GetterTree } from 'vuex';
import { RootState } from '@/plugins/store';
import { PreavisInterventionState } from './state';
import { PreavisInterventionDTO } from '@/models/PreavisIntervention/PreavisInterventionDTO';
import { Site } from '@/models/Site';

export const getters: GetterTree<PreavisInterventionState, RootState> = {
    items(state): PreavisInterventionDTO[] {
        return state.items;
    },
    tableHeader(state) {
        return state.tableHeader;
    },
    tableData(state) {
        return state.items.map(it => ({
            objet: it.objet,
            libelleSite: it.libelleSite,
            materiel: it.equipement?.libelle || '',
            delai: it.delai,
            emails: it.emails || [],
            actif: it.actif,
            actions: '',
            idMasque: it.id,
        }));
    },
    count(state): number {
        return state.items?.length || 0;
    },
    isLoading(state): boolean {
        return state.isLoadingList;
    },
    isSubmitting(state): boolean {
        return state.isSubmitting;
    },
    error(state): string | null | undefined {
        return state.error;
    },
    isModaleOpen(state): boolean {
        return state.isModaleOpen;
    },
    currentSiteId(state): number | undefined {
        return state.currentSiteId;
    },
    currentEquipementId(state): number | undefined {
        return state.currentEquipementId;
    },
    selectedItemId(state): number | null | undefined {
        return state.selectedItemId ?? null;
    },
    getPreavisSite(state): Site | undefined {
        return state.preavisSite;
    },
};
